import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CheckoutRedesign from "./CheckoutRedesign";

// Demo-only page for the "Hé Checkout Redesign". Not wired to any API —
// placing an order just shows the payload the real flow would receive.

const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@600;700&display=swap";

export default function CheckoutDemo() {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(660);
  const [order, setOrder] = useState(null);

  // Load the redesign's fonts only while this page is mounted
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = FONT_HREF;
    document.head.appendChild(link);
    return () => link.remove();
  }, []);

  return (
    <>
      <CheckoutRedesign
        balance={balance}
        onBack={() => navigate(-1)}
        onTopUp={() => setBalance((b) => b + 500)}
        onPlaceOrder={setOrder}
      />

      {order && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setOrder(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(5,4,15,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#120F2E",
              border: "1px solid rgba(227,204,134,0.35)",
              borderRadius: 18,
              padding: 24,
              maxWidth: 420,
              width: "100%",
              color: "#ECE8F7",
              fontFamily: "'DM Sans', system-ui, sans-serif",
            }}
          >
            <h2 style={{ marginTop: 0, color: "#E3CC86", fontFamily: "'Playfair Display', Georgia, serif" }}>
              Order placed (demo)
            </h2>
            <pre style={{ fontSize: 13, color: "#B3ADC9", whiteSpace: "pre-wrap", margin: "0 0 16px" }}>
              {JSON.stringify(order, null, 2)}
            </pre>
            <button
              type="button"
              onClick={() => setOrder(null)}
              style={{
                width: "100%",
                minHeight: 44,
                borderRadius: 22,
                border: 0,
                background: "#E3CC86",
                color: "#17122F",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
